import { EmeraldErrorModal } from 'src/common/api/emerald-error';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { popupMessage } from 'src/messages/business-logic/popup-message';

interface micrRetryProps {
  onRetry: () => void;
  onClose: () => void;
}
export const showMICRErrorModal = (props: micrRetryProps): void => {
  const micrErrorModal = new EmeraldErrorModal({
    message: 'Error',
    type: EmeraldDialogTypes.Error,
    subMessage: 'MicrFailed',
    acceptButtonLabel: 'MicrErrorModal_Retry',
    closeButtonLabel: 'MicrErrorModal_Close',
    onAccept: props.onRetry,
    onCancel: props.onClose,
  });

  popupMessage(micrErrorModal);
};
